/*
 * Placeholder portraits for sample people (stock photos in public/images/avatars).
 * avatarPhoto(seed) always gives the same person the same photo.
 */
export const AVATAR_PHOTOS = Array.from({ length: 8 }, (_, index) => `/images/avatars/avatar-${index + 1}.jpg`)

export const avatarPhoto = (seed: string | number) => {
    const text = String(seed)
    let hash = 0
    for (let index = 0; index < text.length; index++) hash = (hash * 31 + text.charCodeAt(index)) | 0

    return AVATAR_PHOTOS[Math.abs(hash) % AVATAR_PHOTOS.length]
}
